<template>
    <div class="layer-content common" style="height:240px;overflow-y:scroll-y;">
		<div class="info2">접속할 원을 선택하세요.</div>
		<div class="btn-wrap mgt10">
			<button class="wp100 __layer-type01" 
                    :class="index > 0 ? 'mg0 mgt10' : ''"
                    v-for="(fcltInfo, index) in mberSrvcFcltList" 
                    :key="'fcltInfo_'+index" @click="btn_fcltClick(fcltInfo)">
                <span>{{fcltInfo.fcltNm}}</span>
            </button>
		</div>
	</div>
</template>

<script>
export default {
    name : 'selMberSrvcFcltPopup',
    props : ['param'],
    data : function(){
        return {
            mberSrvcFcltList : new Array(),
            srvcCd : '',
            remoteLoginProc : null
        }
    },
    methods : {
        btn_fcltClick : function(fcltInfo){
            this.remoteLoginProc(fcltInfo.fcltcd, this.srvcCd);
            this.$store.commit('closePopup');
        }
    },
    mounted : function(){
        this.mberSrvcFcltList = this.param.mberSrvcFcltList;
        this.srvcCd = this.param.srvcCd;
        this.remoteLoginProc = this.param.remoteLoginProcFunc;
    }
}
</script>